import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandAddprestartPage } from './cabsand-addprestart';

@NgModule({
  declarations: [
    CabsandAddprestartPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandAddprestartPage),
  ],
})
export class CabsandAddprestartPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-addprestart/cabsand-addprestart.module.ts